import { HYDRATE } from "next-redux-wrapper";
import { ActionSearchServices } from "./actions";

const initialState = { data: [], status: "fetch_init", message: "" };

function storeSearchServices(state = initialState, action) {

	switch (action.type) {

	case HYDRATE:
		return { ...state, ...action.payload.storeSearchServices };
	case ActionSearchServices.LOAD_GET_SEARCH_SERVICES:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionSearchServices.RES_GET_SEARCH_SERVICES:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionSearchServices.ERR_GET_SEARCH_SERVICES:
		return {
			...state,
			data: action,
			status: "fetch_error",
			message: "Error...",
		};
	default:
		return { ...state };

	}

}

export default storeSearchServices;
